import type { FunctionComponent } from 'react'
import style from './TitleIconSmall.module.sass'

type TitleIconSmallProps = {
	title: string
	icon: JSX.Element
}

export const TitleIconSmall: FunctionComponent<TitleIconSmallProps> = ({ title, icon }) => {
	return (
		<div className={style.titleWrapper}>
			<span className={style.iconWrapper}>{icon}</span>
			<h4 className={style.title}>{title}</h4>
		</div>
	)
}
